module.exports = __webpack_public_path__ + "static/media/FB_IMG_1614547669829.ce1c0ff5.jpg";